<template>
  <div id="app" ref="body" class="page-id-1 ccm-page page-type-index page-handle-home" v-bind:class="{ 'page-template-index': active }">
    <Navbar/>
    <router-view/>
    <Footer/>
  </div>
</template>
<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'App',
  data: function () {
    	return {
    		active:false,
    	}
	},
  	components: {
    	Navbar,Footer
  	},
	watch: {
	    '$route' () {
	      if (this.$route.path === '/') {
	      	this.active=true;
	      }
	      else {
	      	this.active=false;
	      }  
	    }
	} 	
}
</script>

